import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Snackbar,
  Alert
} from '@mui/material';
import { motion } from 'framer-motion';

// Tab Components
import ElectionDates from '../components/admin/ElectionDates';
import CandidateQueue from '../components/admin/CandidateQueue';
import UserRoles from '../components/admin/UserRoles';
import VoteStatistics from '../components/admin/VoteStatistics';

// Auth Context
import { useAuth } from '../contexts/AuthContext';
import '../styles/shared.css';

const AdminConsole = () => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  
  const handleCloseSnackbar = () => {
    setSuccess('');
    setError('');
  };
  
  // This is where we'd check if the user is actually an admin
  // We're relying on the ProtectedRoute in App.js already checking this
  
  return (
    <div className="page-container">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h3" component="h1" className="page-title">
          Admin Console
        </Typography>
      </motion.div>
      
      <Snackbar 
        open={!!success} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
      </Snackbar>
      
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      
      <Paper
        sx={{
          borderRadius: '16px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(0, 153, 153, 0.15)',
          boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
          overflow: 'hidden',
          mb: 4
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          textColor="inherit"
          indicatorColor="primary"
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              py: 2,
              fontSize: '1rem',
              fontWeight: 500,
              color: '#4a5568', // Dark gray for light theme
              '&.Mui-selected': {
                color: '#2d3748', // Darker for selected
                fontWeight: 600
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#009999', // Teal accent for light theme
              height: '4px',
              borderRadius: '2px'
            },
          }}
        >
          <Tab label="Election Dates" />
          <Tab label="Candidate Queue" />
          <Tab label="User Roles" />
          <Tab label="Vote Statistics" />
        </Tabs>
        
        <Box sx={{ p: 3 }}>
          {tabValue === 0 && (
            <ElectionDates 
              setLoading={setLoading} 
              setError={setError} 
              setSuccess={setSuccess} 
            />
          )}
          {tabValue === 1 && (
            <CandidateQueue 
              setLoading={setLoading} 
              setError={setError} 
              setSuccess={setSuccess} 
            />
          )}
          {tabValue === 2 && (
            <UserRoles 
              setLoading={setLoading} 
              setError={setError} 
              setSuccess={setSuccess} 
            />
          )}
          {tabValue === 3 && (
            <VoteStatistics 
              setLoading={setLoading} 
              setError={setError} 
              setSuccess={setSuccess} 
            />
          )}
        </Box>
      </Paper>
    </div>
  );
};

export default AdminConsole;